import { FC, useEffect, useState } from 'react';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Plus } from '../../icons/plus';

const JsonList: FC<any> = ({ data, index, onChange, callback }) => {
  const [rows, setRows] = useState<string[]>(['']);
  const [validationErrorMessage, setValidationErrorMessage] = useState<string[]>([]); // error msg for individual rows

  const isValidJson = (value: string) => {
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    if (data?.[index]?.value) {
      setRows(data?.[index]?.value);
      setValidationErrorMessage(data?.[index]?.value?.map(() => ''));
    } else {
      setRows(['']);
      setValidationErrorMessage(['']);
    }
  }, []);

  const onSaveHandler = () => {
    const newErrors: any = rows?.map((row) =>
        {
            if (!row.trim()) return 'Row cannot be empty';
            if (!isValidJson(row)) return 'Invalid JSON';
            return '';
        }
    );

    const isListEmpty = rows?.length === 0 || (rows?.length === 1 && !rows?.[0]?.trim());
    if (isListEmpty) {
      newErrors[0] = 'Json cannot be empty';
    }

    const hasError = newErrors.some((error: any) => error !== '');
    setValidationErrorMessage(newErrors);
    if(!hasError && !isListEmpty) {
        onChange(rows, 'value', index);
        
    }
    if(callback && !hasError && !isListEmpty) {
       callback() 
    }
    
  };

  const handleAddRow = () => {
    setRows((prev) => ['', ...prev]);
    setValidationErrorMessage((prev) => ['', ...prev]);
  };

  const handleDeleteRow = (i: number) => {
    setRows((prev) => prev.filter((_, index) => index !== i));
    setValidationErrorMessage((prev) => prev.filter((_, index) => index !== i));
  };

  const handleChange = (i: number, value: string) => {
    const updatedRows = [...rows];
    updatedRows[i] = value;
    setRows(updatedRows);

    // clear error on change
    const updatedErrors = [...validationErrorMessage];
    updatedErrors[i] = '';
    setValidationErrorMessage(updatedErrors);
  };

  return (
    <Box>
      <Box>
        <Typography variant="h5">{data?.[index]?.name || 'JSON List'}</Typography>
        <Typography variant="overline">JSON</Typography>
      </Box>

      <Box>
        <Button
          variant="outlined"
          sx={{ borderColor: 'neutral.300', color: 'text.primary', mt: 1 }}
          size="small"
          onClick={handleAddRow}
        >
          Add JSON <Plus />
        </Button>
      </Box>

      <Box display="flex" flexDirection="column" sx={{ my: 1, height: '60vh', overflow: 'auto' }}>
        {rows.map((value, index) => (
          <Box key={index} display="flex" flexDirection="column" sx={{ my: 1 }}>
            <Box display="flex" alignItems="flex-start">
              <TextField
                fullWidth
                multiline
                minRows={2}
                placeholder={`{\n    "name": "John Doe"\n}`}
                value={value}
                onChange={(e) => handleChange(index, e.target.value)}
                variant="outlined"
                error={!!validationErrorMessage[index]}
                helperText={validationErrorMessage[index]}
              />
              <IconButton
                color="error"
                onClick={() => handleDeleteRow(index)}
                disabled={rows.length === 1}
                sx={{ mt: 1 }}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>

      <Box sx={{ my: 1, display: 'flex', alignItems: 'center' }}>
        <Button variant="contained" size="small" onClick={onSaveHandler}>
          Save
        </Button>
       { 
            validationErrorMessage.some((error: any) => error !== '') && 
            <Typography variant='caption' color='error' sx={{ml:2}}>
                    {validationErrorMessage.filter((errorMessage: any) => errorMessage !== '')?.length} Invalid JSON
            </Typography>
        }
      </Box>
    </Box>
  );
};

export default JsonList;
